export const peCoatedRollsHeroContent = {
  badge: 'Premium Quality Solution',
  scriptTitle: 'Our Sustainable',
  mainTitleLines: ['PE Coated', 'Rolls'],
  kicker: 'Moisture & Grease Barrier Performance',
  descriptions: [
    'Built for food packaging and cup making, our PE coated rolls combine strong moisture and grease barrier performance with reliable converting for long-term freshness and durability.',
    'From disposable cups and liquid wrapping to high-speed punching lines, our coated paper preserves seal integrity and strengthens production efficiency for brands across India.',
  ],
  features: [
    'Moisture Barrier',
    'Heat Sealable',
    'Food Grade Safe',
    'Pan India Supply',
  ],
  imagePrimary: {
    src: '/images/products/pe-coated-rolls.png',
    alt: 'PE coated paper rolls',
  },
  imageSecondary: {
    src: '/images/products/pe-rolls.png',
    alt: 'Industrial PE coated roll manufacturing',
  },
  stampLabel: 'PE Coated',
};
